var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.25C10.7383 5.25 9.875 6.15233 9.875 7.07527V10.375H14.125V7.07527C14.125 6.6051 13.9154 6.15832 13.5386 5.81385C13.1539 5.47299 12.6127 5.25 12 5.25ZM8.125 7.07527V10.375H8C6.89543 10.375 6 11.2704 6 12.375V18.375C6 19.4796 6.89543 20.375 8 20.375H16C17.1046 20.375 18 19.4796 18 18.375V12.375C18 11.2704 17.1046 10.375 16 10.375H15.875V7.07527C15.875 6.05637 15.414 5.15434 14.713 4.51635L14.713 4.51631L14.7058 4.50992C13.9987 3.88048 13.0414 3.5 12 3.5C9.94966 3.5 8.125 5.01711 8.125 7.07527ZM8 12.125C7.86193 12.125 7.75 12.2369 7.75 12.375V18.375C7.75 18.5131 7.86193 18.625 8 18.625H16C16.1381 18.625 16.25 18.5131 16.25 18.375V12.375C16.25 12.2369 16.1381 12.125 16 12.125H8ZM13.25 14.625C13.25 15.034 13.0536 15.397 12.75 15.6251V16.6793C12.75 17.0936 12.4142 17.4293 12 17.4293C11.5858 17.4293 11.25 17.0936 11.25 16.6793V15.6251C10.9464 15.397 10.75 15.034 10.75 14.625C10.75 13.9346 11.3096 13.375 12 13.375C12.6904 13.375 13.25 13.9346 13.25 14.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineLock);
export default __webpack_public_path__ + "static/media/line-lock.f858706167fa0c905b7ae0bc6b4b9173.svg";
export { ForwardRef as ReactComponent };